<template>
  <hub-details />
</template>

<script setup lang="ts">
import { HubDetails } from '~/pages/_components/hub-details';
import LaunchHubHomepage from '../_components/hub-details/_components/launchhub-homepage/LaunchHubHomepage.vue';
import { useHubStore } from '~/store/hub';

const route = useRoute();

const { hub } = storeToRefs(useHubStore());
const hubSlug = computed<string>(() => route.params.hubslug as string);
</script>
